<template>
    <div
        class="slider"
        ref="slider"
    >
        <div
            class="slider-group"
            ref="sliderGroup"
        >
            <slot></slot>
        </div>
        <div
            class="ui-dots tran"
            v-show="showDots"
        >
            <!-- style="bottom:8px" -->
            <span
                class="dot"
                v-if="slideDots && slideDots.length>1"
                v-for="(item, index) in slideDots"
                :class="{addDot: currentPageIndex === index }"
                :key="index"
            ></span>
        </div>
    </div>
</template>
 
<script>
import { addClass } from '../util/common';
import BScroll from 'better-scroll-patch';
export default {
    data() {
        return {
            dots: [],
            currentPageIndex: 0,
            page: 0,
            dot: 'dot'
        };
    },
    props: {
        loop: {
            type: Boolean,
            default: false
        },
        autoPlay: {
            type: Boolean,
            default: false
        },
        interval: {
            type: Number,
            default: 4000
        },
        sum: {
            type: Number,
            default: 1
        },
        slideDots: {
            type: Array,
            default: () => {
                return [];
            }
        },
        showDots: {
            type: Boolean,
            default: false
        },
        /**
         * 列表的数据
         */
        data: {
            type: Array,
            default: null
        },
        speed: {
            type: Number,
            default: 1000
        },
        /**
         * 当数据更新后，刷新scroll的延时。
         */
        refreshDelay: {
            type: Number,
            default: 20
        },
        click: {
            type: Boolean,
            default: true
        },
        threshold: {
            type: Number,
            default: 0.3
        },
        widthType: {
            type: Number,
            default: 1
        },
        offsetWidth: {
            type: Number,
            default: 16
        }
    },
    mounted() {
        this.update();
        window.addEventListener('resize', () => {
            if (!this.slider || !this.slider.enabled) {
                return;
            }
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                if (this.slider && this.slider.isInTransition) {
                    this._onScrollEnd();
                } else {
                    if (this.autoPlay) {
                        this._play();
                    }
                }
                this.refresh();
            }, 60);
        });
    },
    activated() {
        if (!this.slider) {
            return;
        }
        this.slider.enable();
        let pageIndex = this.slider.getCurrentPage().pageX;
        this.slider.goToPage(pageIndex, 0, 0);
        this.currentPageIndex = pageIndex;
        if (this.autoPlay) {
            this._play();
        }
    },
    deactivated() {
        this.slider.disable();
        clearTimeout(this.timer);
    },
    beforeDestroy() {
        this.slider.disable();
        clearTimeout(this.timer);
    },
    methods: {
        update() {
            if (this.slider) {
                this.slider.destroy();
            }
            this.$nextTick(() => {
                this.init();
            });
        },
        refresh() {
            this._setSlideWidth(true);
            if (this.slider) {
                this.slider.refresh();
            }
        },
        prev() {
            if (this.slider) {
                this.slider.prev();
            }
        },
        next() {
            if (this.slider) {
                this.slider.next();
            }
        },
        init() {
            clearTimeout(this.timer);
            this.currentPageIndex = 0;
            this._setSlideWidth();
            if (this.showDot) {
                this._initDots();
            }
            this._initSlide();
            if (this.autoPlay) {
                this._play();
            }
        },
        _setSlideWidth(isResize) {
            this.children = this.$refs.sliderGroup ? this.$refs.sliderGroup.children : [];
            console.log(this.children);
            let width = 0;
            let slideWidth = 0;

            if (this.widthType === 2) {
                for (let i = 0; i < this.children.length; i++) {
                    const child = this.children[i];
                    addClass(child, 'slider-item');
                    width += $(child).width();
                }
                width += this.offsetWidth;
            } else {
                this.$refs.slider && this.$refs.slider.clientWidth && (slideWidth = this.$refs.slider.clientWidth / this.sum);
                for (let i = 0; i < this.children.length; i++) {
                    const child = this.children[i];
                    addClass(child, 'slider-item');
                    child.style.width = slideWidth + 'px';
                    width += slideWidth;
                }
            }

            if (this.children.length > 1) {
                if (this.loop && !isResize) {
                    width += 2 * slideWidth;
                }
            }

            this.$refs.sliderGroup && (this.$refs.sliderGroup.style.width = width + 'px');
        },
        _initSlide() {
            this.slider = new BScroll(this.$refs.slider, {
                scrollX: true,
                scrollY: false,
                momentum: false,
                snap: {
                    loop: this.loop,
                    threshold: this.threshold,
                    speed: this.speed
                },
                snapLoop: true,
                stopPropagation: false,
                preventDefault: false,
                click: this.click,
                flickLimitTime: 200,
                flickLimitDistance: 150
            });

            this.slider.on('scrollEnd', this._onScrollEnd);
            this.slider.on('touchEnd', () => {
                if (this.autoPlay) {
                    this._play();
                }
            });
            this.slider.on('beforeScrollStart', () => {
                if (this.autoPlay) {
                    clearTimeout(this.timer);
                }
            });
        },
        _onScrollEnd() {
            let pageIndex = this.slider.getCurrentPage().pageX;
            this.currentPageIndex = pageIndex;
            this.$emit('scrollEnd', pageIndex);
            if (this.autoPlay) {
                this._play();
            }
        },
        _initDots() {
            let len = 0;
            this.children && (len = this.children.length);
            this.slideDots = new Array(len);
        },
        _play() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (this.slider) {
                    this.slider.next();
                }
            }, this.interval);
        }
    },
    watch: {
        loop() {
            this.update();
        },
        autoPlay() {
            this.update();
        },
        speed() {
            this.update();
        },
        threshold() {
            this.update();
        },
        data() {
            setTimeout(() => {
                this.update();
            }, this.refreshDelay);
        }
    },
    destroyed() {
        this.slider = null;
    }
};
</script>
<style scoped lang="scss">
@import './../scss/mixin.scss';
.slider {
    min-height: 1px;
    position: relative;
    width: 100%;
    overflow: hidden;
}
.slider-group {
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    height: 100%;
}
.slider-item {
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    text-align: center;
}
.slider-item a {
    display: block;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
}
.slider-item img {
    display: block;
    width: 100%;
}

.ui-dots {
    position: absolute;
    right: 0;
    left: 0;
    bottom: $rem18;
    transform: translateZ(1px);
    text-align: center;
    font-size: 0;
}
.dot {
    display: inline-block;
    // margin: 0 4px;
    width: $rem20;
    height: $rem20;
    border-radius: 50%;
    opacity: 0.5;
    background: #ffffff;
    transform: scale(0.5);
    transform-origin: 0% center;
}
.addDot {
    /* background: #ffffff;
  opacity: 1; */
    width: $rem20 !important;
    height: $rem20 !important;
    background: #ffffff;
    opacity: 1;
    border-radius: 50% !important;
    transform: scale(0.5);
    transform-origin: 0% center;
}
.active {
    width: 20px;
    border-radius: 5px;
}
</style>
